import { render, staticRenderFns } from "./CarouselIMG.vue?vue&type=template&id=06e7c71e&scoped=true"
import script from "./CarouselIMG.vue?vue&type=script&lang=js"
export * from "./CarouselIMG.vue?vue&type=script&lang=js"
import style0 from "./CarouselIMG.vue?vue&type=style&index=0&id=06e7c71e&prod&lang=scss&scoped=true"
import style1 from "./CarouselIMG.vue?vue&type=style&index=1&id=06e7c71e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e7c71e",
  null
  
)

export default component.exports